import React, { useEffect } from 'react';
import { Route, Routes, Navigate, useNavigate, useLocation } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Settings from './pages/Settings';
import Orders from './pages/Orders';
import Shipments from './pages/Shipments';
import Login from './Login';
import Security from './pages/Request';
import Solicitudes from './pages/Request';
import Tracking from './pages/tracking';
import Evidence from './pages/Evidence';
import Costing from './pages/Costeo';
import Masivo from './pages/Bulk-movements';
import Inbound from './pages/Inbound';
import Catalogo from './pages/Catalogos';
import Cliente from './pages/Client';
import AccessDenied from './pages/AccessDenied';
import ProtectedRouteWithRole from './components/ProtectedRouteWithRole';
import Home from './pages/Inicio';
import Pool from './pages/Client-pool';
import BIDashboard from './pages/BI-Dashboard';
import TransportAdmin from './pages/TransportAdmin';
import TransportistaDashboard from './pages/TransportistaDashboard';
import ActiveShipments from './pages/ActiveShipments';
import Tickets from './pages/Tickets';
import Anticipo from './pages/anticipo';
import Gasolina from './pages/Gasolina';
import Utilidades from './pages/Utilidades';
import UTR from './pages/Utr';
import Activitylog from './pages/Logs';
import AuditoriasCalidad from './pages/AuditoriasCalidad';
import ConfirmarEmbarque from './pages/ConfirmarEmbarque';
import EvidenceDashboard from './components/dashboards/EvidenceDashboard';
import AuthProvider, { useAuth } from './contexts/AuthContext'; // Importar AuthProvider y useAuth
import { ToastContainer } from 'react-toastify'; // Importamos ToastContainer
import 'react-toastify/dist/ReactToastify.css'; // Importamos los estilos de react-toastify
import SelectSystem from './pages/SelectSystem';
import WmsDashboard from './pages/wms/WmsDashboard';
import WmsProductos from './pages/wms/WmsProductos';
import WmsInventario from './pages/wms/WmsInventario';
import WmsRecepcion from './pages/wms/WmsRecepcion';
import WmsAlmacenaje from './pages/wms/WmsAlmacenaje';
import WmsOrdenes from './pages/wms/WmsOrdenes';
import WmsTrazabilidad from './pages/wms/WmsTrazabilidad';
import WmsReportes from './pages/wms/WmsReportes';
import WmsConfiguracion from './pages/wms/WmsConfiguracion';
import WmsUbicaciones from './pages/wms/WmsUbicaciones';
import WmsOrdenesConsulta from './pages/wms/WmsOrdenesConsulta';
import PutawayFlowPage from './pages/wms/PutawayFlowPage';
import ViajeDetalle from './pages/ViajeDetalle';

import "primereact/resources/themes/lara-light-blue/theme.css"; // Tema claro
import "primereact/resources/primereact.min.css";              // Estilos base
import "primeicons/primeicons.css";    
import WmsAlmacenes from './pages/wms/WmsAlmacenes';
import NuevaAlmacen from './pages/wms/NuevaAlmacen';
import WmsAlmacenDetalle from './pages/wms/WmsAlmacenDetalle';
import WmsUsuarios from './pages/wms/WmsUsuarios';
import WmsOrdenEntrada from './pages/wms/WmsOrdenEntrada';
import WmsOrdenSalida from './pages/wms/WmsOrdenSalida';
import TermsAndConditions from './pages/TermsAndConditions';
import MovimientosInventario from './pages/wms/MovimientosInventario';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

// Definir los roles de WMS y TMS de forma explícita
const WMS_ROLES = [
  'wms_almacenista', 'wms_supervisor', 'wms_operador', 'wms_cliente', 'wms_inventarios', 'wms_auditor', 'wms_logistica', 'admin'
];
const TMS_ROLES = [
  'user', 'admin', 'client','Procurement','Trafico','Documental','Sourcing','Multicuentas','Legal','ControlTower','Propios','transportista'
];

// Componente que valida los permisos al iniciar o refrescar
const PermissionValidator = () => {
  const { isAuthenticated, updatePermissionsConfig } = useAuth();
  const location = useLocation();

  // Verificar permisos al refrescar la página
  useEffect(() => {
    // Solo ejecutamos esta función una vez cuando el componente se monta y está autenticado
    if (isAuthenticated) {
      const validatePermissions = async () => {
        try {
          //console.log('Validando permisos al iniciar/refrescar la aplicación');
          await updatePermissionsConfig();
        } catch (error) {
          //console.error('Error validando permisos:', error);
        }
      };

      validatePermissions();
    }
  }, [isAuthenticated]); // Remover updatePermissionsConfig de las dependencias para evitar el bucle infinito

  return null; // Este componente no renderiza nada
};

function App() {
  const navigate = useNavigate();
  const location = useLocation();

  // Función para manejar el login
  const handleLogin = (credentials) => {
    localStorage.setItem('token', credentials.access_token);
    localStorage.setItem('role', credentials.role);
    navigate('/'); // Redirige al home después del login
  };

  // Verifica autenticación cuando la ruta cambia
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token && location.pathname !== '/login') {
      navigate('/login');
    }
  }, [location.pathname, navigate]);

  return (
    <AuthProvider>
      <PermissionValidator />
      <DndProvider backend={HTML5Backend}>
        <div className="App">
          <Routes>
            {/* Ruta pública */}
            <Route
              path="/login"
              element={
                localStorage.getItem('token') ? (
                  <Navigate to="/" replace />
                ) : (
                  <Login onLogin={handleLogin} />
                )
              }
            />

            {/* Página pública de Términos y Condiciones */}
            <Route path="/terminos-y-condiciones" element={<TermsAndConditions />} />

            {/* Ruta de acceso denegado */}
            <Route path="/access-denied" element={<AccessDenied />} />

            {/* Rutas protegidas */}
            <Route
              path="/"
              element={<SelectSystem />}
            />

            {/* Página de inicio anterior ahora en /inicio */}
            <Route
              path="/inicio"
              element={
                <ProtectedRouteWithRole allowedRoles={['user', 'admin', 'client','Procurement','Trafico','Documental','Sourcing','Multicuentas','Legal','ControlTower','Propios']}>
                  <Home />
                </ProtectedRouteWithRole>
              }
            />

            <Route
              path="/dashboard"
              element={
                <ProtectedRouteWithRole allowedRoles={['user', 'admin']}>
                  <Dashboard />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRouteWithRole  allowedRoles={['user', 'admin', 'client','Procurement','Trafico','Documental','Sourcing','Multicuentas','Legal','ControlTower','Propios']} >
                  <Settings />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/orders"
              element={
                <ProtectedRouteWithRole  allowedRoles={['admin','Procurement','Multicuentas','Propios']}>
                  <Orders />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/Request"
              element={
                <ProtectedRouteWithRole  allowedRoles={['admin']}>
                  <Solicitudes />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/shipments"
              element={
                <ProtectedRouteWithRole  allowedRoles={['admin','user','Procurement','Trafico','Multicuentas','Propios']}>
                  <Shipments />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/Security"
              element={
                <ProtectedRouteWithRole  allowedRoles={['admin','user','Trafico','Multicuentas','Propios']}>
                  <Security />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/tracking"
              element={
                <ProtectedRouteWithRole  allowedRoles={['admin','user','ControlTower','Trafico','Multicuentas','Propios']}>
                  <Tracking />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/evidences"
              element={
                <ProtectedRouteWithRole  allowedRoles={['admin','user','Documental','Trafico','Multicuentas','Propios']}>
                  <Evidence />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/auditorias-calidad"
              element={
                <ProtectedRouteWithRole allowedRoles={['admin', 'user', 'Trafico', 'ControlTower']}>
                  <AuditoriasCalidad />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/confirmar-embarque"
              element={
                <ProtectedRouteWithRole allowedRoles={['admin', 'user', 'Trafico', 'ControlTower']}>
                  <ConfirmarEmbarque />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/costing"
              element={
                <ProtectedRouteWithRole  allowedRoles={['admin','user','Documental']}>
                  <Costing />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/bulk-movements"
              element={
                <ProtectedRouteWithRole allowedRoles={['admin','user','Procurement','Propios']}>
                  <Masivo />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/Inbound"
              element={
                <ProtectedRouteWithRole  allowedRoles={['admin','user','Procurement','Trafico']}>
                  <Inbound />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/Catalogo"
              element={
                <ProtectedRouteWithRole  allowedRoles={['admin','user','Procurement']}>
                  <Catalogo />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/Pool"
              element={
                <ProtectedRouteWithRole  allowedRoles={['admin','client']}>
                  <Pool />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/active-shipments"
              element={
                <ProtectedRouteWithRole  allowedRoles={['admin','ControlTower']}>
                  <ActiveShipments />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/Clientview"
              element={
              //<ProtectedRouteWithRole isAuthenticated={isAuthenticated} allowedRoles={['client', 'admin', 'user']}>
                <Cliente />
              //</ProtectedRouteWithRole>
              }
            />
            
            <Route
              path="/bi-dashboard"
              element={
                <ProtectedRouteWithRole allowedRoles={['admin', 'user', 'ControlTower','Documental','Trafico','Sourcing','Multicuentas','Procurement','Propios']}>
                  <BIDashboard />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/transport-admin"
              element={
                <ProtectedRouteWithRole allowedRoles={['admin','Sourcing']}>
                  <TransportAdmin />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/transportista-dashboard"
              element={
                <ProtectedRouteWithRole allowedRoles={['transportista', 'admin']}>
                  <TransportistaDashboard />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/tickets"
              element={
                <ProtectedRouteWithRole allowedRoles={['admin','Legal']}>
                  <Tickets />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path ="/anticipos"
              element={
                <ProtectedRouteWithRole allowedRoles={['admin','Propios']}>
                  <Anticipo />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path ="/gas-vouchers"
              element={
                <ProtectedRouteWithRole allowedRoles={['admin','Propios']}>
                  <Gasolina />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path ="/utilities"
              element={
                <ProtectedRouteWithRole allowedRoles={['user', 'admin','Procurement','Trafico','Documental','Sourcing','Multicuentas','Legal','ControlTower','Propios']}>
                  <Utilidades />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path ="/utr"
              element={
                <ProtectedRouteWithRole allowedRoles={['admin']}>
                  <UTR />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path ="/logs"
              element={
                <ProtectedRouteWithRole allowedRoles={['admin']}>
                  <Activitylog />
                </ProtectedRouteWithRole>
              }
            />
            
            {/* Agregar la ruta para el dashboard de evidencias */}
            <Route path="/evidence-dashboard" element={
              <ProtectedRouteWithRole allowedRoles={['admin', 'user', 'Documental', 'Trafico', 'Multicuentas', 'Propios']}>
                <EvidenceDashboard />
              </ProtectedRouteWithRole>
            } />

            {/* Rutas para TMS y WMS (puedes personalizar a dónde llevan) */}
            <Route
              path="/tms"
              element={
                <ProtectedRouteWithRole allowedRoles={['user', 'admin', 'client','Procurement','Trafico','Documental','Sourcing','Multicuentas','Legal','ControlTower','Propios']}>
                  <Home /> {/* O la página principal de TMS */}
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/wms"
              element={
                <ProtectedRouteWithRole allowedRoles={WMS_ROLES}>
                  <WmsDashboard />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/wms/dashboard"
              element={
                <ProtectedRouteWithRole allowedRoles={WMS_ROLES}>
                  <WmsDashboard />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/wms/productos"
              element={
                <ProtectedRouteWithRole allowedRoles={WMS_ROLES}>
                  <WmsProductos />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/wms/inventario"
              element={
                <ProtectedRouteWithRole allowedRoles={WMS_ROLES}>
                  <WmsInventario />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/wms/recepcion"
              element={
                <ProtectedRouteWithRole allowedRoles={WMS_ROLES}>
                  <WmsRecepcion />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/wms/almacenaje"
              element={
                <ProtectedRouteWithRole allowedRoles={WMS_ROLES}>
                  <WmsAlmacenaje />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/wms/ordenes"
              element={
                <ProtectedRouteWithRole allowedRoles={WMS_ROLES}>
                  <WmsOrdenes />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/wms/trazabilidad"
              element={
                <ProtectedRouteWithRole allowedRoles={WMS_ROLES}>
                  <WmsTrazabilidad />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/wms/reportes"
              element={
                <ProtectedRouteWithRole allowedRoles={WMS_ROLES}>
                  <WmsReportes />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/wms/configuracion"
              element={
                <ProtectedRouteWithRole allowedRoles={WMS_ROLES}>
                  <WmsConfiguracion />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/wms/ubicaciones"
              element={
                <ProtectedRouteWithRole allowedRoles={WMS_ROLES}>
                  <WmsUbicaciones />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/wms/almacenes"
              element={
                <ProtectedRouteWithRole allowedRoles={WMS_ROLES}>
                  <WmsAlmacenes />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/wms/nueva-almacen"
              element={
                <ProtectedRouteWithRole allowedRoles={WMS_ROLES}>
                  <NuevaAlmacen />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/wms/almacenes/:id"
              element={
                <ProtectedRouteWithRole allowedRoles={WMS_ROLES}>
                  <WmsAlmacenDetalle />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/wms/usuarios"
              element={
                <ProtectedRouteWithRole allowedRoles={['admin']}>
                  <WmsUsuarios />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/wms/inventario/flow/:flowKey"
              element={
                <ProtectedRouteWithRole allowedRoles={WMS_ROLES}>
                  {/* Import dinámico para evitar problemas de importación circular */}
                  {React.createElement(require('./pages/wms/FlowRunner').default)}
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/wms/recepcion/flow/:flowKey"
              element={
                <ProtectedRouteWithRole allowedRoles={WMS_ROLES}>
                  {React.createElement(require('./pages/wms/FlowRunner').default)}
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/wms/ordenes/consulta"
              element={
                <ProtectedRouteWithRole allowedRoles={WMS_ROLES}>
                  <WmsOrdenesConsulta />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/wms/ordenes/entrada"
              element={
                <ProtectedRouteWithRole allowedRoles={WMS_ROLES}>
                  <WmsOrdenEntrada />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/wms/ordenes/salida"
              element={
                <ProtectedRouteWithRole allowedRoles={WMS_ROLES}>
                  <WmsOrdenSalida />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/wms/inventario/movimientos"
              element={
                <ProtectedRouteWithRole allowedRoles={WMS_ROLES}>
                  <MovimientosInventario />
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/wms/putaway-hu"
              element={
                <ProtectedRouteWithRole allowedRoles={WMS_ROLES}>
                  {/* Eliminar la referencia a PutawayHU */}
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/wms/almacenaje/flow/:flowKey"
              element={
                <ProtectedRouteWithRole allowedRoles={WMS_ROLES}>
                  {React.createElement(require('./pages/wms/FlowRunner').default)}
                </ProtectedRouteWithRole>
              }
            />
            <Route
              path="/viaje-detalle/:viajeId"
              element={
                <ProtectedRouteWithRole allowedRoles={['Transportista', 'admin']}>
                  <ViajeDetalle />
                </ProtectedRouteWithRole>
              }
            />
          </Routes>
          
          {/* Componente ToastContainer para mostrar notificaciones */}
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </div>
      </DndProvider>
    </AuthProvider>
  );
}

export default App;